import { useCookies } from "react-cookie";
import * as _ from "lodash";

export const useUserContext = () => {
  const [cookies] = useCookies();
  const currentLoggedInUser = _.get(cookies, "userContext", {});
  return currentLoggedInUser;
};
